import * as React from 'react';

import SourceOptions from '../../interfaces/SourceOptions';

import { Source, Layer } from 'react-mapbox-gl';

interface Props {
  sourceOptions: SourceOptions;
}

const MapTile = ({ sourceOptions }: Props) => {

  return (
    <React.Fragment>
      <Source
        id='source_id'
        tileJsonSource={sourceOptions} />
      <Layer
        before='l_ids'
        type='raster'
        id='layer_id'
        sourceId='source_id' />
    </React.Fragment>
  );
};

export default React.memo(MapTile);
